module.exports = __webpack_public_path__ + "img/top-logo.074923c.png";